(function () {
  'use strict';

  angular
    .module('iqxCore')
    .controller('ReportCtrl', ReportCtrl)


  function ReportCtrl($scope, $q, $routeParams, $filter, FormSvc, ApiSvc, ApplicationSvc) {
    // Controller for rendering selected report
    FormSvc.setOptions($scope, {})

    $scope.getFieldValue = function (row, col) {
      // The display value
      if (!row) { return '' }
      if (col.expandable) { return '' }
      if (col.DataType === 'M') { return $filter('number')(row[col.FieldName], 2) }
      if (col.isDate) { return $filter('date')(row[col.FieldName], 'dd/MM/yyyy') }
      return row[col.FieldName]
    }

    $scope.showRow = function (row) {
      // The filter function to decide if a row is displayed
      var bShow
      if ($scope.cbSummary) {
        bShow = (row.special === '$subTotal$')
      } else if ($scope.cmbSummary) {
        bShow = (row.special === $scope.cmbSummary)
      } else {
        bShow = !row.special
      }
      return bShow
    }

    $scope.showCol = function (col) {
      // The filter function to decide if a column is displayed
      var bShow = !col.hidden
      return bShow
    }

    $scope.clickHeader = function (col) {
      // Handles clicks on column titles, to change sort order
      if (col.expandable) { return }
      if ($scope.sortArray.length === 1 && $scope.sortArray[0] === '+' + col.FieldName) {  // Currently has ascending sort on this col
        $scope.sortArray = ['-' + col.FieldName]  // Change to descending
      } else {
        $scope.sortArray = ['+' + col.FieldName]
      }
    }

    $scope.colExpand = function (row, col) {
      // Handles clicks on an expansion button
      $scope.expansionCaption = ($scope.expandDescripCol ? $scope.getFieldValue(row, $scope.expandDescripCol) + ' ' : '') + col.FieldLabel
      var proc = row[col.FieldName]
      if (!proc) { return }
      if (!/[?]/.test(proc)) {  // Some old procs start params with & instead of ? for some reason
        proc = proc.replace(/[&]/, '?')  // Replace 1st only with correct ?
      }
      return $scope.fetch({
        fetchAPI: 'callresult/' + proc,
        fetchTarget: 'reportExpansionRows', multiRow: true
      })
        .then(function () {
          if ($scope.reportExpansionRows.length === 0) { return ApplicationSvc.showMessage('Info', 'No ' + $scope.expansionCaption + ' available') }
          $scope.reportExpansionCols = []
          var hasDates = false
          angular.forEach($scope.reportExpansionRows[0], function (dataCol, colName) {  // Parse the fields in the first row
            var newCol = { FieldName: colName }  // to create the columns
            var psplit = colName.split(/__/)
            newCol.FieldLabel = psplit[0].replace(/_/g, ' ')
            var opts = ''
            if (psplit.length > 1) { opts = psplit[1].split('') }
            angular.forEach(opts, function (opt) {
              switch (opt) {
                case 'C':
                  newCol.FieldClass = 'textcentre'
                  break
                case 'R':
                  newCol.FieldClass = 'textright'
                  break
                case 'D':
                  col.isDate = true
                  hasDates = true
                case 'M':
                  newCol.DataType = opt
                  break
              }
            })
            $scope.reportExpansionCols.push(newCol)
          })
          if (hasDates) {
            angular.forEach($scope.reportExpansionRows, function (row) {
              angular.forEach($scope.reportExpansionCols, function (col) {
                if (col.isDate) { row[col.FieldName] = ApiSvc.StringToDate(row[col.FieldName]) }
              })
            })
          }
          var data = { reportRows: $scope.reportExpansionRows, reportCols: $scope.reportExpansionCols, choices: [{ desc: 'Close', type: 'primary', code: '' }] }
          FormSvc.modalInfo($scope, 'reportExpansion', data, 'md')  // Display the dialog
        })
    }

    $scope.fetchMetaData = function () {  // Parse the report result fields to generate the columns
      $scope.dataTitle = ''  // Additional title info from the Title__H field
      $scope.filterRow = ''  // The search text
      $scope.sortArray = []  // Array of sort criteria
      $scope.grandTotalRow = undefined  // Displays the total row at the bottom
      $scope.hasGrandTotals = false   // Has a fixed grand total row based on an 'A' column
      $scope.hasDynamicTotals = false  // Has dynamic client calculated totals based on 'T' colunms
      $scope.hasSubtotals = false  // Has fixed subtotal rows based on a 'B' column
      $scope.hasSummaries = false  // Has selectable subtotal rows based on one or more 'S' columns
      $scope.summaryCols = [{ FieldName: '', FieldLabel: '' }]  // The selectable summaries - must have a null option to return to detail
      $scope.expandDescripCol = undefined  // Column providing a row description for expansion dialogs
      $scope.processData = false  // Flag indicating that the row data needs to be pre-processed before rendering
      return $scope.fetch({
        fetchAPI: 'callresult/netreportmetadata?pReport=' + $routeParams.report,
        fetchTarget: 'reportCols', multiRow: true
      })  // Get the fields
        .then(function () {
          if ($scope.reportCols.length === 0) { return $q.reject('Access denied') }
          var numberRegEx = new RegExp('\\b(smallint|integer|numeric|float|double|tinyint|bigint|decimal)$')
          var dateRegEx = new RegExp('^(date|timestamp)$')
          $scope.reportTitle = $scope.reportCols[0].ReportTitle  // Main report title
          angular.forEach($scope.reportCols, function (col) {  // Parse the columns for metadata
            var psplit = col.FieldName.split(/__/)
            col.FieldLabel = psplit[0].replace(/_/g, ' ')
            var opts = ''
            if (psplit.length > 1) { opts = psplit[1].split('') }
            var sortCol = 0
            var sortReverse = false
            angular.forEach(opts, function (opt) {
              switch (opt) {
                case '1':
                case '2':
                case '3':
                case '4':
                case '5':
                case '6':
                case '7':
                case '8':
                case '9':
                  sortCol = Number(opt)
                  break
                case 'Z':
                  sortReverse = true
                  break
                case 'A':
                  col.grandTotal = true
                  $scope.hasGrandTotals = true
                  break
                case 'B':
                  col.subTotal = true
                  $scope.hasSubtotals = true
                  break
                case 'C':
                  col.FieldClass = 'textcentre'
                  break
                case 'R':
                  col.FieldClass = 'textright'
                  break
                case 'D':
                case 'M':
                  col.DataType = opt
                  break
                case 'E':
                  col.expandable = true
                  col.FieldClass = 'no-print textcentre'
                  break
                case 'H':
                  col.hidden = true
                  col.dataTitle = (col.FieldName.substr(0, 8) === 'Title__H')
                  break
                case 'S':
                  col.summary = true
                  $scope.hasSummaries = true
                  $scope.summaryCols.push(col)
                  break
                case 'T':
                  col.dynamicTotal = true
                  $scope.hasDynamicTotals = true
                  break
                case 'G':
                  col.graph = true
                  $scope.hasGraph = true
                  break
                case 'X':
                  col.xAxis = true
                  break
              }
            })
            if (sortCol) {  // Place sortable column in the sortArray
              $scope.sortArray[sortCol - 1] = (sortReverse ? '-' : '+') + col.FieldName
            }
            col.isDate = dateRegEx.test(col.FieldType)
            col.isNumber = numberRegEx.test(col.FieldType)
            if (col.isDate || col.isNumber || col.dataTitle) {
              $scope.processData = true
            }
            if (!$scope.expandDescripCol && !(col.hidden || col.expandable)) { $scope.expandDescripCol = col }  // First visible field
          })
          if ($scope.hasGrandTotals || $scope.hasSubtotals || $scope.hasSummaries) {
            $scope.processData = true
            $scope.hasDynamicTotals = false // not compatible with totals in the data set
          }
          if ($scope.hasDynamicTotals) { $scope.processData = true }
        })
    }

    let paramString = function () {  // Create a URL query string from the route parameters
      var ps = ''
      angular.forEach($routeParams, function (val, key) {
        if (key != 'report') {
          if (ps) { ps = ps + '&' }
          ps = ps + key + '=' + encodeURIComponent(val)
        }
      })
      if (ps) { ps = '?' + ps }
      return ps
    }

    $scope.fetchReportData = function () {
      return $scope.fetch({
        fetchAPI: 'callresult/' + $routeParams.report + paramString(),
        fetchTarget: 'reportRows', multiRow: true
      })
        .then(function () {
          if ($scope.processData) {   // Pre-process the data if necessary
            angular.forEach($scope.reportRows, function (row) {
              var filledSummaries = 0, lastFilledSummary
              angular.forEach($scope.reportCols, function (col) {
                if (col.isDate) {
                  row[col.FieldName] = ApiSvc.StringToDate(row[col.FieldName])
                } else if (col.isNumber) {
                  row[col.FieldName] = Number(row[col.FieldName])
                }
                if (col.grandTotal && !row[col.FieldName]) {
                  $scope.grandTotalRow = angular.copy(row)
                  row.special = '$grandTotal$'
                }
                if (col.subTotal && !row[col.FieldName]) {
                  row.special = '$subTotal$'
                }
                if (col.dataTitle && !$scope.dataTitle && row[col.FieldName]) {
                  $scope.dataTitle = row[col.FieldName]
                }
                if ((col.summary || col.subTotal) && row[col.FieldName]) {
                  filledSummaries++
                  lastFilledSummary = col
                }
                if ($scope.hasDynamicTotals && col.dynamicTotal) {
                  if (!$scope.grandTotalRow) { $scope.grandTotalRow = {} }
                  $scope.grandTotalRow[col.FieldName] = ($scope.grandTotalRow[col.FieldName] || 0) + (row[col.FieldName] || 0)
                }
              })
              if ($scope.hasSummaries) {
                if (filledSummaries === 0 && !$scope.hasGrandTotals) {
                  $scope.grandTotalRow = angular.copy(row)
                  row.special = '$grandTotal$'
                } else if (filledSummaries === 1 && lastFilledSummary.summary) {
                  row.special = lastFilledSummary.FieldName
                }
              }
            })
          }
        })
    }

    $scope.drawGraph = function () {
      var xCol, datasets = []
      angular.forEach($scope.reportCols, function (col) {
        if (col.xAxis) { xCol = col }
        if (col.graph) { datasets.push({ label: col.FieldLabel, iqFieldName: col.FieldName, data: [] }) }
      })

      if (!xCol || !xCol.isDate || !datasets.length) return $scope.formError = 'Error: missing or non-date X column or no graphable columns'
      angular.forEach($scope.reportRows, function (row) {
        angular.forEach(datasets, function (ds) {  // If hasSubtotals, graph the subtotal rows, otherwise graph the detail rows
          if (($scope.hasSubtotals && row.special === '$subTotal$') || (!$scope.hasSubtotals && !row.special)) {
            ds.data.push({ x: row[xCol.FieldName], y: row[ds.iqFieldName] })
          }
        })
      })
      angular.forEach(datasets, function (ds) {
        ds.data.sort(function (a, b) { return a.x.getTime() - b.x.getTime() })  // Sort into x date order
      })

      $scope.graphOptions = {
        responsive: true,
        title: {
          display: false,
          text: ''
        },
        scales: {
          xAxes: [{
            type: 'time',
            time: {
              //unit: 'day',
              round: 'day'
            },
            display: true,
            scaleLabel: {
              display: true,
              labelString: xCol.FieldLabel
            }
          },],
          yAxes: [{
            display: true,
            scaleLabel: {
              display: false,
              labelString: ''
            }
          }]
        }
      }
      $scope.graphData = { datasets: datasets }
      $scope.graphDrawn = true
    }

    $scope.hideGraph = function () {
      $scope.graphData = null  // Will destroy the chart object and free the memory
      $scope.graphDrawn = false
    }

    // Put it all together
    $scope.fetchMetaData()
      .then(function () {
        return $scope.fetchReportData()
      })
  }
})()
